import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TableAdmin from "../../components/adminTable";
import { TailSpin } from "react-loader-spinner";
import DeleteAdmin from "./delete-admin";
import SuspendAdmin from "./suspend-admin";

const AdminTable = ({ data, selectedRole, activeTab, loading }: any) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState<string | null>(null);
  const [isSuspended, setIsSuspended] = useState(false);
  const [toggleSuspensionId, setToggleSuspensionId] = useState<string | null>(
    null
  );
  const columns = [
    { header: "", accessor: "fullname" },
    {
      header: activeTab === "merchant" ? "Business Name" : "Name",
      accessor: "fullname",
    },
    { header: "Email Address", accessor: "email" },
    { header: "Phone No", accessor: "phone" },
    { header: "Roles", accessor: "role" },
    { header: " ", accessor: "id" },
  ];

  useEffect(() => {
    const filtered = data.filter((admin: any) => {
      if (admin.status) {
        return true;
      }
      return false;
    });
    setFilteredData(filtered);
    setIsLoading(false);
  }, [data, selectedRole]);

  const handleUserClick = (id: string) => {
    navigate(`/admins/detail/${id}`);
  };

  const handleDeleteAdmin = (id: string) => {
    setSelectedUserId(id);
  };

  const handleToggleSuspension = (id: string) => {
    setToggleSuspensionId(id);
  };

  const handleCloseModal = () => {
    setSelectedUserId(null);
    setToggleSuspensionId(null);
  };

  return (
    <div>
      {loading || isLoading ? (
        <div className="flex justify-center items-center h-64">
          <TailSpin color="skyblue" />
        </div>
      ) : filteredData.length > 0 ? (
        <TableAdmin
          columns={columns}
          data={filteredData}
          selectedUserId={null}
          onUserClick={handleUserClick}
          onDeleteAdmin={handleDeleteAdmin}
          onToggleSuspension={handleToggleSuspension}
          setIsSuspended={(val: boolean) => setIsSuspended(val)}
        />
      ) : (
        <div className="flex justify-center items-center h-64">
          <p className="text-gray-500 text-lg">No data available</p>
        </div>
      )}

      {selectedUserId && (
        <DeleteAdmin
          visible={!!selectedUserId}
          handleClose={handleCloseModal}
          id={selectedUserId}
        />
      )}
      {toggleSuspensionId && (
        <SuspendAdmin
          visible={!!toggleSuspensionId}
          handleClose={handleCloseModal}
          id={toggleSuspensionId}
          isSuspended={isSuspended}
        />
      )}
    </div>
  );
};

export default AdminTable;
